import { Wallet, TrendingUp, Sparkles, Banknote } from "lucide-react";
import { fmtMoney } from "@/lib/finance";

const Card = ({ testId, label, value, sub, icon: Icon, accent, delay }) => (
  <div
    data-testid={testId}
    className="glass rounded-xl border border-[#232D40] p-5 sm:p-6 rise relative overflow-hidden group hover:border-[#2f3c54] transition-colors"
    style={{ animationDelay: `${delay}ms` }}
  >
    <div className={`absolute -right-6 -top-6 h-24 w-24 rounded-full blur-2xl opacity-20 ${accent.glow}`} />
    <div className="flex items-start justify-between relative">
      <div>
        <p className="text-xs uppercase tracking-wider text-slate-400 font-medium">{label}</p>
        <p className={`mt-2 text-2xl sm:text-3xl font-extrabold font-mono-data tracking-tight ${accent.text}`}>
          {value}
        </p>
        {sub && <p className="mt-1 text-xs text-slate-500 font-mono-data">{sub}</p>}
      </div>
      <div className={`h-10 w-10 rounded-lg flex items-center justify-center ${accent.bg}`}>
        <Icon className={`h-5 w-5 ${accent.text}`} />
      </div>
    </div>
  </div>
);

export const KpiCards = ({ live }) => {
  const cards = [
    {
      testId: "kpi-total-active-capital", label: "Total Active Capital",
      value: fmtMoney(live.total_active_capital), sub: `${live.active_tranche_count || 0} active tranches`,
      icon: Wallet, accent: { text: "text-slate-100", bg: "bg-slate-500/10", glow: "bg-slate-400" },
    },
    {
      testId: "kpi-total-accrued-yield", label: "Total Accrued Yield",
      value: fmtMoney(live.total_accrued_yield), sub: `Net bal ${fmtMoney(live.total_current_balance, 0)} · −${fmtMoney(live.total_deducted || 0, 0)} drawn`,
      icon: TrendingUp, accent: { text: "text-emerald-400", bg: "bg-emerald-500/10", glow: "bg-emerald-400" },
    },
    {
      testId: "kpi-todays-profit", label: "Today's Profit (+5%)",
      value: fmtMoney(live.todays_profit), sub: "Rolling 24h compounding delta",
      icon: Sparkles, accent: { text: "text-amber-400", bg: "bg-amber-500/10", glow: "bg-amber-400" },
    },
    {
      testId: "kpi-total-payouts", label: "Total Liquidated Payouts",
      value: fmtMoney(live.total_liquidated_payouts), sub: "Settled withdrawals",
      icon: Banknote, accent: { text: "text-cyan-400", bg: "bg-cyan-500/10", glow: "bg-cyan-400" },
    },
  ];
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
      {cards.map((c, i) => <Card key={c.testId} {...c} delay={i * 80} />)}
    </div>
  );
};
